import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ModalController, NavController, LoadingController } from '@ionic/angular';

import { ActivatedRoute } from '@angular/router';

import * as _ from 'underscore';
import { SimpleTimer } from 'ng2-simple-timer';

import { Utilities } from '@common/utilities';
import { Assessment } from '@common/models/assessment.model';
import { Quiz } from '@common/models/quiz.model';
import { Game } from '@common/models/game.model';

import { NavigationEnum } from '@enums/NavigationEnum';

import { HomeService } from '@services/home.service';
import { AssessmentService } from '@services/assessment.service';
import { QuizService } from '@services/quiz.service';
import { GameService } from '@services/game.service';
import { gameConfig } from '../../../app.constants.config';

import {
  SwiperConfigInterface,
  SwiperComponent
} from 'ngx-swiper-wrapper';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-quizone',
  templateUrl: './quiz-one.component.html',
  styleUrls: ['./quiz-one.component.scss']
})
export class QuizoneComponent extends Utilities implements OnInit, AfterViewInit {
  @ViewChild(SwiperComponent, { static: true }) swiper?: SwiperComponent;
  navigationEnum = NavigationEnum;
  swiperConfig: SwiperConfigInterface = {};
  progress: number = 0;
  swiperHeight: string = "85%";
  errorL = false;
  errorR = false;
  isCorrect         = true;
  taskSwitchingResultsObject: any;

  showGameTitle     = this.assessmentService.showGameTitle;
  showPracticeTitle = this.assessmentService.showPracticeTitle;
  showFixationPoint = this.assessmentService.showFixationPoint;
  showReadyTitle    = this.assessmentService.showReadyTitle;
  showQuestionGrid  = this.assessmentService.showQuestionGrid;
  showAnswerGrid    = this.assessmentService.showAnswerGrid;
  
  showPlay          = this.assessmentService.showPlay;
  showPractice      = this.assessmentService.showPractice;
  showHowTo         = this.assessmentService.showHowTo;

  assessmentObject  = this.assessmentService.assessmentObject;
  game1             = this.assessmentService.game1;
  timerId           = this.assessmentService.timerId;
  gameIndex         = this.assessmentService.gameIndex;
  quizIndex         = this.assessmentService.quizIndex;
  gameId            = this.assessmentService.gameId;
  quizObject        = this.assessmentService.quizObject;
  gameObject        = this.assessmentService.gameObject;
  quiz              = this.assessmentService.quiz;
  quizStartTime     = this.assessmentService.quizStartTime;
  utGameConfig      = this.assessmentService.utGameConfig;

  gameScore         = 0;
  quizIds           = [];
  gameAccuracy      = [];
  reactionTime      = [];
  questionCategory  = [];
  switchStatus = [];
  trialType = [];
  

  
  @ViewChild('mySwiper') mySwiper: SwiperComponent;
  constructor(
    public navCtrl: NavController,
    public modalController: ModalController,
    private route: ActivatedRoute,
    private assessmentService: AssessmentService,
    private st: SimpleTimer,
    public loadingCtrl: LoadingController,
    public quizService: QuizService,
    public gameService: GameService,
    private homeService: HomeService

  ) { super(navCtrl); }

  ngOnInit() {
    const assessmentId = this.route.snapshot.paramMap.get('id');
    // this.numbers = Array(16).fill(16).map((x: any, i: number) => i); // [0,1,2,3,4]
    // this.selectedCell = Array(16).fill(false);
    this.getAssessmentById(assessmentId);
    this.setProgressColor();
    this.assessmentService.current_quiz.next(1);
  }

  ngAfterViewInit() {
    // swiper configuration
    this.swiperConfig = {
      slidesPerView: 1,
      loop: false,
      effect: 'slide',
      speed: 1,
      noSwiping: true,
      noSwipingClass: 'be-no-swiping'
    };
  }

  
  /**
   * Checks if the user selected answer is correct.
   * @param i The index of the quiz.
   * @param option The selected option.
   * @param answer The answer to the quiz.
   */
  async checkAnswer(i: any, option: string, answer: string) {
    /**
    * This function gets called automatically if timer limit reached so 
    * we wont have the index so if not we have access to the previous index.
    */
    if (i !== null) {
      this.quizIndex = i;
    } else {
      this.quizIndex = this.quizIndex + 1;
    }

    this.updateProgress();
    const j = this.quizIndex + 1;
    const gameSetting = this.assessmentService.getGameLimit(this.quizObject[this.quizIndex].game_id);
    const timeStopped = new Date();
    this.st.unsubscribe(this.timerId);

    if (answer) {
      if (!this.isQuestionReal(this.quizObject[this.quizIndex].practice,
        this.quizObject[this.quizIndex].instruction)
        && option !== answer) {
        this.isCorrect = false;
        if(answer === 'R') {
          this.errorR = true;
        } else {
          this.errorL = true;
        }
      } else {
        this.isCorrect = true;
        this.errorR = false;
        this.errorL = false;
      }
    }

    if (this.isQuestionReal(this.quizObject[this.quizIndex].practice,
      this.quizObject[this.quizIndex].instruction)) {
      if (this.quizObject[this.quizIndex].category) {
        const reactionTime = timeStopped.getTime() - this.quizStartTime;
        if (answer && option === answer) {
          this.gameScore = this.gameScore + this.quizObject[this.quizIndex].points;
          this.gameAccuracy.push(true);
        } else {
          this.gameAccuracy.push(false);
        }
        this.questionCategory.push(this.quizObject[this.quizIndex].category);
        this.reactionTime.push(reactionTime);
        this.quizIds.push(this.quizObject[this.quizIndex].id);
        if (this.quizObject[this.quizIndex].game_id === this.game1) {
          const switchVal = this.isSwitch(this.quizObject[this.quizIndex - 1].coordinates,
            this.quizObject[this.quizIndex].coordinates);
          this.switchStatus.push(switchVal);
          const newCoordinates = this.quizObject[this.quizIndex].coordinates.replace(/-/g, ' ');
          this.trialType.push(newCoordinates + ' ' + switchVal);
        }
      }
    }

    if (this.isCorrect) {
      if (j < this.quizObject.length) {
        /*Check the quizObject if the next index is a new game display game header
        * save points for the game id then swipe
        */
        if (this.quizObject[this.quizIndex].game_id !== this.quizObject[j].game_id) {
          // Grab the game id for the next game so we can display the appropriate information
          this.gameId = this.quizObject[j].game_id;
          this.getGameById(this.gameId);
          this.swiper.directiveRef.nextSlide();
          this.showGameTitle = true;
          this.showPracticeTitle = false;
        } else {
          /**
           * if the current game is instruction and the upcoming game is a practice
           * we show the intro to the practice
           */
          if (this.quizObject[this.quizIndex].instruction && this.quizObject[j].practice) {
            this.showPracticeTitle = true;
          }
          /**
           * if the current game is not a quiz and the upcoming game is a quiz
           * we show the intro to the actual game
           */
          if (!this.quizObject[this.quizIndex].quiz && this.quizObject[j].quiz) {
            this.showReadyTitle = true;
          }

          if (this.isQuestionReal(this.quizObject[j].practice,
            this.quizObject[j].instruction) && !this.showReadyTitle) {
            if (gameSetting.fixationPoint) {
              this.showFixationPoint = true;
              this.st.newTimer('1sec', 1, true);
              this.timerId = this.st.subscribe('1sec', () => {
                this.showFixationPoint = false;
                this.st.unsubscribe(this.timerId);
                const d = new Date();
                this.quizStartTime = d.getTime();
                if (gameSetting.questionTime !== 0) {
                  this.st.newTimer('5sec', gameSetting.questionTime, true);
                  this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(null,
                    this.quizObject[this.quizIndex].answer, ' '));
                }
              });
            } else {
              const d = new Date();
              this.quizStartTime = d.getTime();
              if (gameSetting.questionTime !== 0) {
                this.st.newTimer('5sec', gameSetting.questionTime, true);
                this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(null,
                  this.quizObject[this.quizIndex].answer, ' '));
              }
            }
          }

          if (!this.quizObject[j].answer && !this.showReadyTitle && !this.showPracticeTitle) {
            // this.st.newTimer('5sec', 5, true);
            // this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(null,
            //   null, null));
          }
          this.swiper.directiveRef.nextSlide();
        }
      } else {
        const assObj = {
          game_id: this.quizObject[this.quizIndex].game_id,
          game_score: this.gameScore,
          game_accuracy: this.gameAccuracy,
          reaction_time: this.reactionTime,
          switch_status: this.switchStatus,
          category: this.questionCategory,
          quiz_ids: this.quizIds,
          trial_type: this.trialType
        };
        this.taskSwitchingResultsObject = this.calculateSummary(assObj);
        const mergedObject = { ...assObj, ...this.taskSwitchingResultsObject };
        this.assessmentObject.game_score = (this.assessmentObject.game_score || 0) + assObj.game_score;
        if (!this.assessmentObject.results_data) {
          this.assessmentObject.results_data = [];
        }
        this.assessmentObject.results_data.push(mergedObject);
        this.assessmentService.saveAssessment(this.assessmentObject);
        this.assessmentService.nextQuiz(2);
      }
    }
  }


  /**
   * Gets the assessment by the id.
   * @param id A string of the assessment id.
   */
  getAssessmentById(id: string): void {
    this.showLoading();
    this.assessmentService.getAssessmentById(id).then((data: Assessment) => {
      this.assessmentObject = data;

      // Fetch Quizzes for Each Game
      this.getQuizzesForGame(this.game1);
      
      this.gameId = this.assessmentObject.game_ids[0];
      this.getGameById(this.gameId);
    }).catch(() => {
      this.assessmentService.criticalAssessmentFailure();
    });
  }

  /**
   * Gets all the quiz questions based on the game's id, type and limit.
   * @param gameId A string of the game's id.
   */
  getQuizzesForGame(gameId: string): void {
    const quiz        = 'quiz';
    const practice    = 'practice';
    const instruction = 'instruction';
    this.utGameConfig   = gameConfig;

    // Get Eash Game Limits
    const gameSetting = this.assessmentService.getGameLimit(gameId);

    /*************************************** ADD INSTRUCTIONS *************************************************/
    this.quizService.getQuizByType(gameId, instruction, gameSetting.inslimit).pipe(take(1)).subscribe((insObj: Quiz[]) => {

      if (this.quizObject == null) {
        this.quizObject = insObj;
      } else {
        Array.prototype.push.apply(this.quizObject, insObj);
      }
    });

    /*************************************** ADD PRACTICE *************************************************/
    this.quizService.getQuizByType(gameId, practice, gameSetting.practlimit).pipe(take(1)).subscribe((pracObj: Quiz[]) => {
      Array.prototype.push.apply(this.quizObject, pracObj);
    });
   
    /*************************************** ADD QUIZZES *************************************************/
    this.quizService.getQuizByType(gameId, quiz, gameSetting.quizlimit).pipe(take(1)).subscribe(async (quizObj: Quiz[]) => {

      let tempAll = []; // Contains All Quizzes including quizzes generated on the front end

      tempAll = await this.assessmentService.randomizeQuiz(quizObj, gameId); // Randomize Quiz

      Array.prototype.push.apply(this.quizObject, tempAll);
      this.hidLoading();

    });
  }

  /**
   * Navigates to the second quiz.
   */
  startQuiz2(): void {
    this.navigateToPath(
      'assessment/quiz-two/',
      NavigationEnum.Forward
    );
  }


  /**
   * Gets the game by the inputted id.
   * @param id The game's id.
   */
  getGameById(id: any): void {
    if (id) {
      this.gameService.getGameById(id).then((data: Game) => {
        this.gameObject = data;
      });
    }
  }

  /**
   * Hides the game title from the user.
   * @param i The index of the quiz.
   */
  hideGameTitle(i: any): void {
    setTimeout(() => {
      this.mySwiper.directiveRef.update();
    }, 1000);
    this.quizIndex = i;
    this.showGameTitle = false;
    this.gameIndex = i + 1;
    const gameSetting = this.assessmentService.getGameLimit(this.quizObject[this.quizIndex].game_id);
    this.swiperHeight = "95.6%";

    if (this.quizObject[this.quizIndex].practice) {
      this.showPracticeTitle = true;
      // ensure that we pull and display info here
    } else {
      this.showPracticeTitle = false;
      if (this.isQuestionReal(this.quizObject[this.quizIndex].practice, this.quizObject[this.quizIndex].instruction)) {
        const d = new Date();
        this.quizStartTime = d.getTime();
        if (gameSetting.questionTime !== 0) {
          this.st.newTimer('5sec', gameSetting.questionTime, true);
          this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(this.quizIndex,
            this.quizObject[this.quizIndex].answer, null));
        }
      }
    }
  }

  /**
   * Ensures the practice title is hidden for the quiz.
   * @param i The index of the quiz/page.
   */
  hidePracticeTitle(i: any): void {
    setTimeout(() => {
      this.mySwiper.directiveRef.update();
    }, 1000);
    this.quizIndex = i;
    this.showGameTitle = false;
    this.showPracticeTitle = false;
    this.showHowTo = false;
    this.showPractice = true;
    if (!this.quizObject[this.quizIndex].answer) {
      this.st.newTimer('5sec', 1, true);
      this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(this.quizIndex,
        null, null));
    }
  }

  /**
   * Hides the result title.
   * @param i The index of the quiz.
   */
  hideResultTitle(i: any): void {
    setTimeout(() => {
      this.mySwiper.directiveRef.update();
    }, 1000);
    this.quizIndex = i;
    this.showReadyTitle = false;
    this.showPractice = false;
    this.showPlay = false;
    
    const gameSetting = this.assessmentService.getGameLimit(this.quizObject[this.quizIndex].game_id);

    if (this.isQuestionReal(this.quizObject[i].practice, this.quizObject[i].instruction)) {
      if (this.quizObject[this.quizIndex].answer) {
        const d = new Date();
        this.quizStartTime = d.getTime();
        if (gameSetting.questionTime !== 0) {
          this.st.newTimer('5sec', gameSetting.questionTime, true);
          this.timerId = this.st.subscribe('5sec', () => this.checkAnswer(this.quizIndex,
            this.quizObject[this.quizIndex].answer, ''));
        }
      }
    }
  }

  /**
   * Checks if the question is a real question.
   * @param a The first boolean value.
   * @param b The second boolean value.
   */
  isQuestionReal(a: boolean, b: boolean): boolean {
    if (!a && !b) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Sets the quiz index.
   * @param i The number to set the quiz index to.
   */
  trackIndex(i: number): void {
    this.quizIndex = i;
  }

  /**
   * Checks if the question displayed is switch or non switch
   * preceded by a shape of the same color = non-switch or preceded by a shape of a different color = switch.
   * @param a The coordinates of the first question.
   * @param b The coordinates of the second question.
   */
  isSwitch(a, b): 'non-switch'| 'switch' {
    if (a.indexOf('blue') >= 0 && b.indexOf('blue') >= 0 || a.indexOf('red') >= 0 && b.indexOf('red') >= 0) {
      return 'non-switch';
    } else {
      return 'switch';
    }
  }

  /**
   * Calculates the detailed summary of the results for this quiz.
   * @param scoreObject Contains the score settings such as game accuracy.
   * @returns An analysis of the user's quiz.
   */
  calculateSummary(scoreObject): any {
    let switchAccuracy = 0;//
    let switchCount = 0;//
    let nonSwitchAccuracy = 0;//
    let nonSwitchCount = 0;//
    let switchReactionTime = 0;
    let nonSwitchReactionTime = 0;
    let taskSwitchAnalysis = {};
    let correct_reaction_time = 0;
    scoreObject.switch_status.forEach((item, key) => {
      if (item === 'switch') {
        switchCount++;
        if (scoreObject.game_accuracy[key]) {
          switchAccuracy++;
        }
        switchReactionTime += Number(scoreObject.reaction_time[key] || 0);
      } else {
        nonSwitchCount++;
        if (scoreObject.game_accuracy[key]) {
          nonSwitchAccuracy++;
        }
        nonSwitchReactionTime += Number(scoreObject.reaction_time[key] || 0);
      }
    });
    scoreObject.game_accuracy.forEach((item, index) => {
      if(item) {
        correct_reaction_time += scoreObject.reaction_time[index];
      }
    });
    taskSwitchAnalysis = {
      switch_accuracy: switchAccuracy,
      count_of_switch_questions: switchCount,
      non_switch_accuracy: nonSwitchAccuracy,
      count_of_non_switch_questions: nonSwitchCount,
      switch_reaction_time: switchReactionTime,
      non_switch_reaction_time: nonSwitchReactionTime,
      correct_reaction_time
    };

    return taskSwitchAnalysis;
  }

  /**
   * Updates the progress percentage.
   */
  updateProgress(): void {
    const progress = (this.quizIndex+1) / this.quizObject.length;
    this.assessmentService.current_progress.next(progress);
  }

  /**
   * Sets the progress bar with the cobranding color.
   */
  setProgressColor(): void {
    var sheet = document.styleSheets[0];
    this.homeService.getCobranding().subscribe(cobrand => {
      sheet.insertRule(`ion-progress-bar{--progress-background:${cobrand.darkPrimary}}`);
    });
    
  }
}
